/* Build & price a package (Trailer Town): a base trailer (one product per hitch) plus 1-N matching bins, e.g. Horizon HRD roll off
   trailer + HDZ roll off dumpsters. Each part keeps its own price file and Shopify prices (see build-price.js); bins always match
   the trailer's deck length. Sends one package request to the Stryker Pro quote form. */
(() => {
  const root = document.getElementById("build-package");
  const BP = window.BuildPrice;
  if (!root || !BP) return;
  const { esc, usd, cleanDesc, perFt } = BP;
  const q = n => root.querySelector(`[data-bp="${n}"]`);
  const bar = document.querySelector('[data-bp="bar"]');
  const parts = BP.readJSON(root.querySelector("[data-bpk-parts]"));
  const maxBins = +root.dataset.maxBins || 4;
  let T = [], B = null, hitch = 0, bins = 1, busy = false;
  const cur = () => T[hitch];
  const form = BP.formSync(root, () => buildText(), () => ({ total: totals().total, sku: `${cur().C.S.v.sku} + ${bins}x ${B.S.v.sku}` }));

  function renderHitch() {
    q("hitch").innerHTML = T.map((t, i) => {
      const from = Math.min(...t.C.variants.map(v => v.price));
      return `<button type="button" class="bp-len bpk-hitch" data-hitch="${i}" aria-pressed="${i === hitch}"><b>${esc(t.label)}</b><small>trailer from ${usd(from)}</small></button>`;
    }).join("");
    T.forEach((t, i) => { t.el.hidden = i !== hitch; });
  }
  function renderBins() {
    const L = cur().C.S.v.length;
    q("binMatch").textContent = `${L}′ ${B.D.model} bins to fit your ${L}′ trailer`;
    q("binQty").innerHTML = Array.from({ length: maxBins }, (_, i) => i + 1).map(n =>
      `<button type="button" class="bp-len" data-bins="${n}" aria-pressed="${n === bins}"><b>${n}</b><small>${n === 1 ? "bin" : "bins"} · ${usd(n * B.totals().total)}</small></button>`).join("");
  }
  function totals() {
    const t = cur().C.totals(), b = B.totals();
    return { trailer: t, bin: b, binEach: b.total, total: t.total + bins * b.total };
  }
  function label() { return `${cur().C.modelLabel()} ${cur().C.D.model} ${cur().label} + ${bins} × ${B.modelLabel()} ${B.D.model} bin${bins === 1 ? "" : "s"}`; }
  function renderSummary() {
    const x = totals(), tc = cur().C, L = tc.S.v.length;
    q("sumTitle").textContent = label();
    q("sumColor").textContent = `Trailer color: ${tc.S.color || "not picked yet"} · Bin color: ${B.colorText() || "not picked yet"}`;
    const line = (cls, a, b) => `<div class="bp-line${cls}"><span>${a}</span><span>${b}</span></div>`;
    q("lines").innerHTML =
      line(" base", `${esc(tc.modelLabel())} ${esc(tc.D.model)} ${esc(cur().label)} trailer, standard features`, usd(tc.S.v.price)) +
      x.trailer.picks.map(o => line("", `${esc(cleanDesc(o.desc))}${tc.qtyOf(o) > 1 && !perFt(o) ? ` × ${tc.qtyOf(o)}` : ""}`, "+" + usd(tc.lineTotal(o)))).join("") +
      line(" base bpk-gap", `${bins} × ${L}′ ${esc(B.D.model)} roll off bin${bins === 1 ? "" : "s"}${bins > 1 ? ` (${usd(B.S.v.price)} each)` : ""}`, usd(bins * B.S.v.price)) +
      x.bin.picks.map(o => line("", `${esc(cleanDesc(o.desc))}${bins > 1 ? ` (${bins} bins × ${usd(B.lineTotal(o))})` : ""}`, "+" + usd(bins * B.lineTotal(o)))).join("");
    q("total").textContent = usd(x.total);
    if (bar) { bar.querySelector('[data-bp="barTotal"]').textContent = usd(x.total); bar.querySelector('[data-bp="barSub"]').textContent = `${L}′ trailer + ${bins} bin${bins === 1 ? "" : "s"}`; }
    form.update();
  }
  function buildText() {
    const x = totals(), tc = cur().C;
    return `${root.dataset.product} | Trailer: ${tc.D.model} ${cur().label} ${tc.modelLabel()} (${tc.S.v.sku}) ${usd(tc.S.v.price)} | Trailer color: ${tc.S.color || "not picked"}` +
      ` | Trailer options: ${tc.optText() || "none"}` +
      ` | Bins: ${bins} x ${B.D.model} ${B.modelLabel()} (${B.S.v.sku}) ${usd(B.S.v.price)} each | Bin color: ${B.colorText() || "not picked"}` +
      ` | Bin options (each bin): ${B.optText() || "none"} | Bins as built: ${bins} x ${usd(x.binEach)} = ${usd(bins * x.binEach)}` +
      ` | Package list price as built: ${usd(x.total)}`;
  }
  // Keep the bins on the trailer's length, then redraw everything that depends on both.
  function sync() {
    if (busy || !B) return;
    busy = true;
    const L = cur().C.S.v.length;
    if (B.S.v.length !== L) B.pickLength(L, true); else B.render(true);
    renderHitch(); renderBins(); renderSummary();
    busy = false;
  }

  root.addEventListener("click", e => {
    const h = e.target.closest("[data-hitch]");
    if (h) {   // switch hitch, keeping the deck length and (if the new trailer has none yet) the color
      const L = cur().C.S.v.length, color = cur().C.S.color;
      hitch = +h.dataset.hitch;
      if (!cur().C.S.color) cur().C.S.color = color;
      cur().C.pickLength(L, true); sync(); return;
    }
    const n = e.target.closest("[data-bins]"); if (n) { bins = +n.dataset.bins; sync(); }
  });

  Promise.all(parts.trailers.map(t => BP.load(t.prices, t.variants)).concat(BP.load(parts.bin.prices, parts.bin.variants))).then(res => {
    const bin = res.pop();
    const binLens = bin.variants.map(v => v.length);
    T = parts.trailers.map((t, i) => {
      const el = root.querySelector(`[data-bpk-trailer="${i}"]`);
      const variants = res[i].variants.filter(v => binLens.includes(v.length));   // only lengths a bin fits
      return { label: t.label, el, C: BP.Configurator(el, res[i].D, variants, { onChange: sync }) };
    }).filter(t => t.C.variants.length);
    if (!T.length) throw new Error("no trailers");
    B = BP.Configurator(q("binPanel"), bin.D, bin.variants, { lengths: L => L === cur().C.S.v.length, matchColor: () => cur().C.S.color, onChange: sync, each: true, noun: "bin" });
    const pick = new URLSearchParams(location.search);
    const hq = (pick.get("hitch") || "").toLowerCase();   // ?hitch=pintle&length=16 preselects
    if (hq) { const h = T.findIndex(t => t.label.toLowerCase().startsWith(hq)); if (h >= 0) hitch = h; }
    const L = +(pick.get("length") || 0);
    T.forEach(t => t.C.pickLength(L || t.C.variants[0].length, true));
    T.forEach(t => t.C.render(true));
    sync();
    window.__buildPackage = { T, B, totals, buildText };   // for QA
  }).catch(() => {
    q("binPanel").innerHTML = `<p class="bp-note">The package builder didn't load. Refresh the page, or call ${esc(root.dataset.phone)} for a quote.</p>`;
    q("formNote").textContent = "Fill in your details and we'll get back to you with pricing.";
    root.querySelector("[data-stryker-pdp-trigger]")?.click();   // still offer the form, just without a build
  });
})();
